var exports = {
  "k": "x31de4314--050f85--container",
  "D": "x31de4314--050f85--search-string-block",
};

module.exports = exports;
